// extracted by mini-css-extract-plugin
export default {"downloadHistoryWrapper":"DownloadHistory_downloadHistoryWrapper__Gac6W","downloadHistoryTableContainer":"DownloadHistory_downloadHistoryTableContainer__p+Vxy"};